import Icon from '@material-ui/icons/ShoppingBasket'; // TODO change
import List from './List';
import Show from './Show';


export {
  List,
  Show,
  Icon,
};



// WEBPACK FOOTER //
// ./src/components/OfferWatch/index.js